export const dataFaq = [
  {
    title: 'Wie kann ich FOXI nutzen?',
    description:
      'Du kannst FOXI einfach und sofort in jedem Browser öffnen. Du brauchst nur eine Internetverbindung. Für die Sprachaufnahme kannst Du auch unsere Apps für Android oder iOS nutzen.',
  },
  {
    title: 'Was macht FOXI so besonders?',
    description:
      'FOXI wurde von Zahnärzten für Zahnärzte entwickelt. Du gibst nur das ein, was Du behandelt hast. Endlich brauchst Du keine Vorkenntnisse in den Positionen der Abrechnung mehr: FOXI erstellt die Leistungsübersicht automatisch und beachtet sämtliche Regeln und Gesetze der Abrechnung. So landen selbst komplizierte Einträge schnell und vorallem korrekt in der Patientenakte.',
  },
  {
    title: 'Wie kann ich mit FOXI meinen Umsatz steigern?',
    description:
      'Durch unkorrekte Abrechnung oder vergessene Positionen gehen einer Zahnarztpraxis im Durchschnitt 15% des Umsatzes verloren. Mit FOXI werden automatisch alle Positionen beachtet, niemals etwas vergessen, und beispielsweise auch Zuschläge optimiert.',
  },
  {
    title: 'Was kostet FOXI?',
    description:
      'Für 1-Behandler-Praxen ist FOXI ab 249€ + USt. pro Monat erhältlich. Ab zwei Behandlern sind die Kosten 149€ + USt. pro Monat pro Behandler (2 Beh.: 298€ + USt., 3 Beh.: 447€ + USt., usw.).  In den Kosten sind alle Einstellungen, Anpassungen, Support und Schulungen der Mitarbeiter enthalten. Wir begleiten Dich sehr eng bei der Umsetzung in Deiner Praxis. Wenn Du nur an Dokumentation per Sprachassistent interessiert bist, dann haben wir auch günstigere Tarife. Du kannst FOXI kostenlos testen.',
  },
  {
    title:
      'Wie ist die vollständige Abrechnung und Dokumentation einer Implantation mit Sinuslift in nur 5 Minuten überhaupt möglich?',
    description:
      "Wir sind sehr stolz auf unser Produkt und wie intuitiv und schnell man damit arbeiten kann. Probier' es aus und überzeug' Dich selbst!",
  },
  {
    title: 'Wer in meinem Team kann FOXI nutzen?',
    description:
      'Jeder kann es nutzen! Durch FOXI kannst Du auf handschriftliche Notizen, was Du genau in welcher Behandlung gemacht hast, komplett verzichten. Beispielsweise kann die Eingabe einer Behandlung mit FOXI on-the-fly während einer Behandlung erfolgen. Mit FOXI musst Du kaum noch Zeit für die Abrechnung verwenden, schon gar nicht Deine Wochenenden!',
  },
  {
    title: 'Wie wird FOXI mit bestehender Zahnarztsoftware integriert?',
    description:
      'FOXI ist mit allen PVS (Praxisverwaltungsystemen) kompatibel. Leistungen und Dokumentation werden sofort mit einem Klick in Deine Praxissoftware übernommen.',
  },
  {
    title: 'Wie funktioniert Datensicherheit bei FOXI?',
    description:
      'Alle Daten werden DSGVO-konform gespeichert. Unsere App läuft auf zertifizierten Servern in Deutschland und unterstützt moderne Datenschutz-Standards.',
  },
];
